import { Component, input, output, computed, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { S25IconComponent } from "../modules/s25-icon/s25.icon.component";
import { TypeManagerDecorator } from "../main/type.map.service";

@TypeManagerDecorator("s25-ng-load-more")
@Component({
    selector: "s25-ng-load-more",
    template: `
        @if (hasMore()) {
            <div class="load-more-wrapper">
                <div class="load-more-info">Showing {{ currentCount() }} of {{ totalCount() }}</div>

                <button class="load-more-btn" [disabled]="isLoading()" (click)="onLoadMore()">
                    @if (isLoading()) {
                        <s25-ng-icon [type]="'refresh'" [size]="16" class="spinning"></s25-ng-icon>
                        <span>Loading...</span>
                    } @else {
                        <span>Load More</span>
                        <s25-ng-icon [type]="'arrowDown'" [size]="16"></s25-ng-icon>
                    }
                </button>
            </div>
        } @else if (currentCount() > 0) {
            <div class="load-more-wrapper">
                <div class="load-more-info">All {{ totalCount() }} items loaded</div>
            </div>
        }
    `,
    styles: `
        .load-more-wrapper {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 1rem;
            padding: 2rem 0;
        }

        .load-more-info {
            font-size: 14px;
            color: #64748b;
        }

        .load-more-btn {
            display: inline-flex;
            align-items: center;
            gap: 0.5rem;
            padding: 0.75rem 2rem;
            background: white;
            border: 2px solid #e2e8f0;
            border-radius: 8px;
            font-size: 16px;
            font-weight: 600;
            color: #0066cc;
            cursor: pointer;
            transition: all 0.2s ease;
        }

        .load-more-btn:hover:not(:disabled) {
            background: #f1f5f9;
            border-color: #0066cc;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 102, 204, 0.15);
        }

        .load-more-btn:active:not(:disabled) {
            transform: translateY(0);
        }

        .load-more-btn:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }

        ::ng-deep .spinning svg {
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            from {
                transform: rotate(0deg);
            }
            to {
                transform: rotate(360deg);
            }
        }
    `,
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, S25IconComponent],
})
export class S25LoadMoreComponent {
    // Inputs
    currentCount = input.required<number>();
    totalCount = input.required<number>();
    isLoading = input<boolean>(false);

    loadMore = output<void>();
    hasMore = computed(() => this.currentCount() < this.totalCount());

    onLoadMore(): void {
        if (this.hasMore() && !this.isLoading()) {
            this.loadMore.emit();
        }
    }
}
